import Flex from '@deprecated-ui/common/Flex';
import Text from '@deprecated-ui/common/Text';
import Button from '@deprecated-ui/common/Button';
import Iconmoon from '@deprecated-ui/common/Iconmoon';
import { PopoverContentWrapper } from '@deprecated-ui/common/Popover';
import color from '@deprecated-ui/_style/color';
import Link from 'next/link';
import { useSelector } from 'react-redux';
import { CompanyChartData } from 'lib/entities/company.types';
import { useMemo } from 'react';
import { withMaintenanceGuard } from 'global/Securities/utils/maintenance';
import { showTradingModalWithAuth } from 'features/securities/AuthModal/utils';
import { AUTH_ORDER_TYPE } from 'features/securities/AuthModal/constants';
import { selectors as profileSelectors } from 'lib/entities/profile';
import If from '../../../../ErrorHandlers/If';
import { ButtonFooter, PlainChart } from '../../styled';
import StockChart from './StockChart';
import StockChangeWrapper from './StockChangeWrapper';
import utilsCompany from '../../../../../utils/company';

const { isReksaDana } = utilsCompany;

const navsLabel = {
  keystats: 'Key Stats',
  financials: 'Financials',
  fundachart: 'Fundachart',
  chartbit: 'Chartbit',
};

interface PopoverContentCompanyProps {
  symbol: string;
  chart: CompanyChartData;
  currentSymbol: any;
  handleFollowCompany: () => void;
}

const PopoverContentCompany = ({
  symbol,
  chart,
  currentSymbol,
  handleFollowCompany,
}: PopoverContentCompanyProps) => {
  const { data: profileData } = useSelector(profileSelectors);
  const { country = 'ID' } = profileData;
  const navs = useMemo(() => {
    if (!currentSymbol || currentSymbol.type_company !== 'Saham') {
      return ['chartbit'];
    }
    if (currentSymbol?.country === 'ID') {
      return ['keystats', 'financials', 'fundachart', 'chartbit'];
    }
    return ['keystats', 'chartbit'];
  }, [currentSymbol]);

  const onBuyBottonClick = () =>
    withMaintenanceGuard(() => {
      showTradingModalWithAuth({
        symbol,
        orderType: AUTH_ORDER_TYPE.BUY,
      });
    });

  return (
    <PopoverContentWrapper data-cy="stream-popover-company-content">
      <If condition={country === 'ID'}>
        <PlainChart>
          <StockChart chart={chart} />
        </PlainChart>
        <Flex justify="space-between" padding="10px">
          <StockChangeWrapper symbol={currentSymbol} />
          <Flex>
            <Button
              height="30px"
              // @ts-expect-error
              padding="0 8px"
              margin="0 5px"
              round
              onClick={handleFollowCompany}
            >
              <Iconmoon
                className={
                  currentSymbol?.followed
                    ? 'icon-toolbar_check'
                    : 'icon-toolbar_plus'
                }
                size="14px"
                color={color.primary}
              />
            </Button>
            <If
              condition={
                currentSymbol?.tradeable &&
                !isReksaDana(currentSymbol?.type_company)
              }
            >
              <Button
                data-cy="stream-popover-company-buy"
                type="primary"
                height="30px"
                // @ts-expect-error
                padding="0 25px"
                round
                onClick={onBuyBottonClick}
              >
                <Text color={color.light} align="center">
                  Buy
                </Text>
              </Button>
            </If>
          </Flex>
        </Flex>
        <Flex>
          {navs.map((tab) => (
            <Link key={tab} href={`/symbol/${symbol}/${tab}`} passHref>
              <ButtonFooter as="a">
                <Text align="center" as="span">
                  {navsLabel[tab]}
                </Text>
              </ButtonFooter>
            </Link>
          ))}
        </Flex>
      </If>
      <If condition={country === 'MY'}>
        <div style={{ height: 200 }} />
      </If>
    </PopoverContentWrapper>
  );
};

export default PopoverContentCompany;
